import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import GroheCartHeaderCommon from "./groheCartHeaderCommon";
import {getCartItemsCount} from "../groheNavigation/groheFunctions";

const GroheCartHeader = (props) => {

  const {cartItems, intl} = props;

  const cartItemsLength = getCartItemsCount(cartItems, intl);

  return (
    <GroheCartHeaderCommon title="grohe.cart.header.title" subTitle="grohe.cart.header.subTitle" withSave={true} afterTitle={(
      <Fragment>
        ({cartItemsLength} <FormattedMessage id="look.list.header.items"/>)
      </Fragment>
    )}/>
  )
};


const mapStateToProps = (store) => {
  const {cartItems} = store.cartState;
  return {
    cartItems,
  };
};

export default injectIntl(
  connect(mapStateToProps)(GroheCartHeader)
)
